import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiChatService } from '@app/core/services/ai-chat.service';
import { AiChatItem, AiModelItem } from '@app/core/services/ai-chat.types';

@Component({
    selector: 'tt-ai-chat-header',
    templateUrl: './ai-chat-header.component.html',
    styleUrls: ['./ai-chat-header.component.css'],
    standalone: false,
})
export class AiChatHeaderComponent {
    public readonly models$ = this.aiChat.models$.asObservable();

    @Input()
    public selectedChat?: AiChatItem;

    @Input()
    public selectedModelKeyno = '';

    @Input()
    public showChats = false;

    /** Whether the current portal user may open AI configuration. */
    @Input()
    public canEditConfiguration = false;

    /** Whether the chat may be opened in its StateModal view. */
    @Input()
    public canOpenInModal = false;

    @Output()
    public toggleChats = new EventEmitter<void>();

    @Output()
    public newChat = new EventEmitter<void>();

    @Output()
    public configuration = new EventEmitter<void>();

    @Output()
    public openInModal = new EventEmitter<void>();

    constructor(private aiChat: AiChatService) {}

    public getSelectedModelName(models: AiModelItem[]): string | undefined {
        return models.find((model) => model.ai_model_keyno === this.selectedModelKeyno)?.ai_provider_model_name;
    }
}
